import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';


@Component({
  selector: 'app-unsuscribe',
  templateUrl: './unsuscribe.component.html',
  styleUrls: ['./unsuscribe.component.scss']
})
export class UnsuscribeComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private service: UserService) { }

  step = 1;
  token;

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(d=>{
      if(d.token){
        this.token = d.token;
        this.step = 2;
      }
    })
  }

  confirm(){
    this.service.unsubscribe(this.token).toPromise().then(result=>{
       this.step = 3;
    }).catch( er => {this.step=4});
    
  }

}
